const TOKEN_KEY = 'access_token'
const TOKEN_EXPIRY = 'access_token_expiry'
const REFRESH_TOKEN_KEY = 'refresh_token'

// neither f7 nor store work in this service. so desktop flag have to passed from referrer when saving data.

const TokenService = {
    getToken: function(){
        return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
        // return 'b9cf43539e68f7d2e29f20956d29afca'
    },

    saveToken: function(accessToken, isDesktop) {
        if(isDesktop){
            sessionStorage.removeItem(TOKEN_KEY)
            sessionStorage.setItem(TOKEN_KEY, accessToken)
        } else {
            localStorage.removeItem(TOKEN_KEY)
            localStorage.setItem(TOKEN_KEY, accessToken)
        }
    },

    removeToken: function(){
        sessionStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(TOKEN_KEY)
    },

    getTokenExpiry: function(){
        return sessionStorage.getItem(TOKEN_EXPIRY) || localStorage.getItem(TOKEN_EXPIRY)
        // return 'b9cf43539e68f7d2e29f20956d29afca'
    },

    saveTokenExpiry: function(accessTokenExpiry, isDesktop) {
        if(isDesktop){
            sessionStorage.removeItem(TOKEN_EXPIRY)
            sessionStorage.setItem(TOKEN_EXPIRY, accessTokenExpiry)
        } else {
            localStorage.removeItem(TOKEN_EXPIRY)
            localStorage.setItem(TOKEN_EXPIRY, accessTokenExpiry)
        }
    },

    removeTokenExpiry: function(){
        sessionStorage.removeItem(TOKEN_EXPIRY)
        localStorage.removeItem(TOKEN_EXPIRY)
    },

    getRefreshToken: function(){
        return sessionStorage.getItem(REFRESH_TOKEN_KEY) || localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken: function(refreshToken, isDesktop) {
        if(isDesktop){
            sessionStorage.removeItem(REFRESH_TOKEN_KEY)
            sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
        } else {
            localStorage.removeItem(REFRESH_TOKEN_KEY)
            localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
        }
    },

    removeRefreshToken: function(){
        sessionStorage.removeItem(REFRESH_TOKEN_KEY)
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    }

}

export default TokenService